// src/components/CreatorList.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import md5 from 'md5';
import Background from './Background';
import ButtonSec from './ButtonSec';
import Button from './Button';
import LinkButton from './LinkButton';
import Menu from './Menu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentSlash, faCaretRight, faCaretLeft, faCircleQuestion } from '@fortawesome/free-solid-svg-icons';

const CreatorList = () => {
  const [creators, setCreators] = useState([]);
  const [visibleCount, setVisibleCount] = useState(10);
  const [offset, setOffset] = useState(0);
  const [backwardOffset, setBackwardOffset] = useState(0);
  const publicKey = process.env.REACT_APP_MARVEL_PUBLIC_KEY;
  const privateKey = process.env.REACT_APP_MARVEL_PRIVATE_KEY;
  const [copyright, setCopyright] = useState('');

  useEffect(() => {
    const timestamp = new Date().getTime();
    const hash = md5(`${timestamp}${privateKey}${publicKey}`);

    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://gateway.marvel.com/v1/public/creators?apikey=${publicKey}&ts=${timestamp}&hash=${hash}&limit=${visibleCount}&offset=${offset - backwardOffset}`
        );
        setCreators(response.data.data.results);
        // Informacja o prawach autorskich
        const copyrightText = response.data.attributionText;
        setCopyright(copyrightText);
      } catch (error) {
        console.error('Error fetching creators:', error);
      }
    };

    fetchData();
  }, [privateKey, publicKey, visibleCount, offset, backwardOffset]);

  const handleShowMore = () => {
    setOffset((prevOffset) => prevOffset + visibleCount);
  };

  const handleShowLess = () => {
    setBackwardOffset((prevBackwardOffset) =>
      prevBackwardOffset + visibleCount <= offset ? prevBackwardOffset + visibleCount : 0
    );
  };

  const totalPages = Math.ceil(creators.length / visibleCount);
  const currentPage = Math.ceil((offset - backwardOffset) / visibleCount) + 1;


  return (
    <Background>
      <div className='flex flex-col'>
      <Menu textVariable='Marvel Creators' />
        <ul className='divide-y divide-slate-100'>
        {creators.length > 0 ? (
          creators.map((creator) => (
            <li className='py-4' key={creator.id}>
              <div className='flex'>
                <div className='w-1/5'>
                  <img className="w-full" src={`${creator.thumbnail.path}/portrait_uncanny.${creator.thumbnail.extension}`} alt={creator.title} />
                </div>
                <div className="w-4/5 ml-3">
                  <p className="text-2xl font-medium text-slate-100">{creator.title}</p>
                  <p className='text-2xl font-medium text-slate-100'>{creator.fullName}</p>
                  <p className='text-l text-slate-50 truncate'>{creator.role}</p>
                  <p className='text-l text-slate-100'>Comics available: {creator.comics.available}</p>
                  <p className='text-l text-slate-100'>Series available: {creator.series.available}</p>
                  <p className='text-l text-slate-100'>Stories available: {creator.stories.available}</p>

                  <LinkButton to={`/creator/${creator.id}`}><Button>Creator info</Button></LinkButton>
                </div>
              </div>
            </li>
          ))
        )  : (
          <li className='py-4'>
            <div className='flex justify-center items-center'>
              <img src="/images/logo/loading-29.gif" alt="loading-29"/>
            </div>
          </li>
        )}
        </ul>

        <div className='flex flex-row justify-center items-center py-4 border-t border-slate-100'>
            <div className='text-xl text-slate-100'><FontAwesomeIcon onClick={handleShowLess} icon={faCaretLeft}/>&emsp;Navigation - Page {currentPage}&emsp;<FontAwesomeIcon onClick={handleShowMore} icon={faCaretRight}/></div>
          </div>
          <div className='flex flex-row justify-center'>
            <div className='flex-basis-2/4 mb-2'><ButtonSec onClick={handleShowLess}>Previous</ButtonSec></div>
            <div className='flex-basis-2/4 mb-2'><ButtonSec onClick={handleShowMore}>Next</ButtonSec></div>
          </div>
          <div className='flex flex-row justify-center border-t border-slate-100 py-4'>
            <img src="/images/logo/mv_app_logo_mini.png" alt="mv-logo-app-mini"/>
          </div>
          <div className='flex flex-col justify-center items-center'>
            <div className='w-4/4 text-m text-slate-50 justify-center'><p>{copyright}</p></div>
            <div className='w-4/4 text-m text-slate-50 justify-center'><p>App PCh</p></div>
          </div>


      </div>

      {/* <div>
      <pre>{JSON.stringify(creators, null, 2)}</pre>
      </div> */}

    </Background>
  );
};

export default CreatorList;
